import React from 'react';

export const Content = ({ title, subtitle, children }) => {
    return (
        <div className="content">
            <div className="f-header-content f-header-content--centralizado">
                <h1 className="f-header-content_title">{title}</h1>
                <h2 className="f-header-content__descricao">{subtitle}</h2>
            </div>

            {children}
        </div>
    );
};
